const testWebp = () => document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0;
const isSupported = testWebp();
export default isSupported;